import formConfig from './csc';

describe('csc SCS appointments config', () => {
  it('labels completed approval returns as submitted', () => {
    expect(formConfig.statusOverride?.submitted).toBe('Submitted');
  });

  it('adds SCS appointments after Internal competitions with mandatory tables and textareas', () => {
    const quarterlySection = formConfig.sections.find(
      (section) => section.slug === 'your-quarterly-data-return',
    );

    const subsectionSlugs = quarterlySection?.subsections.map((subsection) => subsection.slug);
    expect(subsectionSlugs).toEqual(
      expect.arrayContaining(['internal-competitions', 'scs-appointments']),
    );
    expect(subsectionSlugs?.indexOf('scs-appointments')).toBe(
      (subsectionSlugs?.indexOf('internal-competitions') ?? -2) + 1,
    );

    const appointmentsSubsection = quarterlySection?.subsections.find(
      (subsection) => subsection.slug === 'scs-appointments',
    );
    expect(appointmentsSubsection?.title).toBe('SCS appointments');

    const page = appointmentsSubsection?.pages[0];
    expect(page?.pageType).toBe('question');
    if (page?.pageType !== 'question') throw new Error('Expected question page');

    expect(page.questions?.map((question) => question.title)).toEqual([
      'SCS interim appointments',
      '#4 For the interim postholders referenced in #3, please provide any explanatory detail for the expected length of post',
      'Substantive appointments',
      '#9 For the interim postholders referenced in #8, please provide any explanatory detail for the length of the interim post.',
    ]);
    expect(page.questions?.map((question) => question.questionType)).toEqual([
      'dynamicTable',
      'textarea',
      'dynamicTable',
      'textarea',
    ]);
    expect(page.questions?.every((question) => question.rules?.required === true)).toBe(true);
    expect(page.questions?.[1].hint).toBe(
      'Please enter "N/a" if there were no relevant appointment',
    );
    expect(page.questions?.[3].hint).toBe(
      'Please enter "N/a" if there were no relevant appointment',
    );

    expect(page.questions?.[0].dynamicTable?.rows.map((row) => row.label)).toEqual([
      '#1 As of the start of this reporting quarter, how many substantive posts are currently held by an interim postholder?',
      '#2 Of the interim postholders listed in response to #1, how many are expected to have a total appointment duration of between 6 and 12 months?',
      '#3 Of the interim postholders listed in response to #1, how many are expected to have a total appointment duration of more than 12 months?',
    ]);
    expect(page.questions?.[0].dynamicTable?.rows[1].lessThanOrEqualToRow).toBe(
      'interimPostholders',
    );
    expect(page.questions?.[0].dynamicTable?.rows[2].lessThanOrEqualToRow).toBe(
      'interimPostholders',
    );
    expect(page.questions?.[0].dynamicTable?.rows[2].setQuestionWhenRowTotalEquals).toEqual({
      value: 0,
      targetQuestion: 'interim-more-than-twelve-months-detail',
      targetValue: 'N/a',
    });
    expect(page.questions?.[2].dynamicTable?.rows.map((row) => row.label)).toEqual([
      '#5 How many permanent appointments externally advertised were made to SCS grades in this reporting quarter',
      '#6 Of the appointments listed in #5, how many of the appointed candidates had previously held the role on an interim basis?',
      '#7 Of the interim postholders who were later substantively appointed as listed in #6, how many had held the role for between 6 and 12 months?',
      '#8 Of the interim postholders later substantively appointed as listed in #7, how many had held the role for more than 12 months?',
    ]);
    expect(page.questions?.[2].dynamicTable?.rows[0].hint).toBe(
      'Current reporting period: {{REPORTING_PERIOD_LABEL}}',
    );
    expect(page.questions?.[2].dynamicTable?.rows[1].lessThanOrEqualToRow).toBe(
      'externallyAdvertisedAppointments',
    );
    expect(page.questions?.[2].dynamicTable?.rows[2].lessThanOrEqualToRow).toBe(
      'previouslyInterimAppointments',
    );
    expect(page.questions?.[2].dynamicTable?.rows[3].lessThanOrEqualToRow).toBe(
      'appointedAfterSixToTwelveMonths',
    );
    expect(page.questions?.[2].dynamicTable?.rows[3].setQuestionWhenRowTotalEquals).toEqual({
      value: 0,
      targetQuestion: 'appointed-more-than-twelve-months-detail',
      targetValue: 'N/a',
    });
  });
});
